export const googleMapsBaseUrl = 'https://www.google.com/maps?q=';
